export class AccountInfo {
    nickname: string | undefined;
    email: string | undefined;
    password: string | undefined;
}
